export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: 'en',
  strictMessage: false,
  missingWarn: false,
  fallbackWarn: false,
}))
